import axios from 'axios'

import { API_ROUTE } from '../config'
import { ACTION_LOGOUT } from '../store/types/user.types'
import store from '../store/store.js'

export const fetch = axios.create({
  baseURL: API_ROUTE,
})

/* eslint-disable no-param-reassign */
fetch.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) config.headers['X-Auth-Token'] = token
    return config
  },
  error => Promise.reject(error),
)
/* eslint-enable no-param-reassign */

fetch.interceptors.response.use(
  (response) => {
    if (response.data.status === 'error') throw new Error(response.errors[0])
    return response
  },
  (error) => {
    const authorizationError = 401
    const forbiddenError = 403
    const loginRequest = error.request.responseURL.includes('login')

    return new Promise((resolve, reject) => {
      if (error.response.status === authorizationError || forbiddenError) {
        store.dispatch(ACTION_LOGOUT)
        if (loginRequest) reject(error)
      } else {
        reject(error)
      }
    })
  },
)
